export const SHARE = {
  getFacebookURL: () => {
    const url = getCurrentUrl();
    return url ? `https://www.facebook.com/sharer.php?u=${url}` : '#';
  },
  getLinkedInURL: (title?: string) => {
    const url = getCurrentUrl();
    if (url) {
      if (title) {
        return `https://www.linkedin.com/shareArticle?url=${url}&title=${title}`;
      }
      return `https://www.linkedin.com/shareArticle?url=${url}`;
    } else {
      return '#';
    }
  },
};

const getCurrentUrl = (): string | undefined => {
  let url;
  if (typeof window !== `undefined`) {
    url = window.location.href;
  }
  return url;
};
